export default async function selectFloorPlans({ state }, guestCardFloorPlanIds) {
  state.set(['locatorTours', 'guestCardFloorPlanIds'], guestCardFloorPlanIds);
  state.commit();
}
